import React from 'react';
import { NumericFormat } from 'react-number-format';

interface YearInputProps {
  value: number;
  customInput: React.ComponentType;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputProps?: any;
}

const YearInput = ({ value, customInput, onChange, inputProps }: YearInputProps) => (
  <NumericFormat
    aria-labelledby="date-input"
    value={value}
    onChange={onChange}
    customInput={customInput}
    type="tel"
    {...inputProps}
  />
);

export default YearInput;
